module.exports = __webpack_public_path__ + "img/setting.915705dd.svg";